// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"cb77941a","428":"cb77941a"}[chunkId] + ".chunk.css";
};